import { forwardRef, HtmlHTMLAttributes, memo } from "react";
import classNames from "classnames";
import { Button, ButtonProps } from "../../Button";
import { SettingsIcon } from "../icons";

import styles from "./style.module.scss"

export type CommandBarFooterProps = {
  contentClassName?: string
  buttonProps?: ButtonProps | false
} & HtmlHTMLAttributes<HTMLDivElement>

export const CommandBarFooter = memo(forwardRef<HTMLDivElement, CommandBarFooterProps>((
  {
    children,
    className,
    buttonProps,
    contentClassName,
    ...props
  }, ref) => {
  return (
    <div
      className={classNames(className, styles.root)}
      {...props}
      ref={ref}
    >
      <div className={classNames(contentClassName, styles.content)}>
        {children}
      </div>
      {buttonProps &&
        <Button
          buttonType={"tertiaryGray"}
          buttonSize={"sm"}
          children={<SettingsIcon />}
          {...buttonProps}
        />
      }
    </div>
  );
}));